(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ImpactPenalitRemiseRegulContratDialogController', ImpactPenalitRemiseRegulContratDialogController);

    ImpactPenalitRemiseRegulContratDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity',
        'ImpactPenalitRemiseRegul', 'TypeAvoir', 'TypeRemisecommerciale', 'LigneContrat'];

    function ImpactPenalitRemiseRegulContratDialogController($scope, $stateParams, $uibModalInstance, entity,
        ImpactPenalitRemiseRegul, TypeAvoir, TypeRemisecommerciale, LigneContrat) {
        var vm = this;
        vm.impactPenalitRemiseRegul = entity;
        vm.typeAvoirs = TypeAvoir.query();
        vm.typeremisecommerciales = TypeRemisecommerciale.query();
        vm.lignecontrats = [];

        vm.clear = clear;
        vm.save = save;
        vm.getRemainingToBePaid = getRemainingToBePaid;
        vm.getAllocatedTotal = getAllocatedTotal;
        vm.getCurrentBaseTotal = getCurrentBaseTotal;
        vm.hasValidAllocatedTotal = hasValidAllocatedTotal;
        vm.updateSuggestedAllocations = updateSuggestedAllocations;

        loadEligibleLines();

        function loadEligibleLines() {
            LigneContrat.findActifByContrat({idContrat: $stateParams.id}).$promise.then(function(result) {
                vm.lignecontrats = result.filter(isEligibleLine);
                angular.forEach(vm.lignecontrats, function(ligneContrat) {
                    ligneContrat.montantAffecte = 0;
                });
            });
        }

        function isEligibleLine(ligneContrat) {
            if (!ligneContrat || ligneContrat.closed === true || !ligneContrat.serviceVendu) {
                return false;
            }

            if (vm.impactPenalitRemiseRegul.type === 'DISCOUNT') {
                if (ligneContrat.serviceVendu.typePaiement === 'A_PAYER_AVEC_ECHELONNEMENT') {
                    return false;
                }
                if (ligneContrat.serviceVendu.typePaiement === 'A_PAYER_EN_UNE_FOIS'
                    && hasExistingBilling(ligneContrat)) {
                    return false;
                }
                return true;
            }

            return hasExistingBilling(ligneContrat);
        }

        function getRemainingToBePaid(ligneContrat) {
            var currentBalance = getCurrentBalance(ligneContrat);

            if (vm.impactPenalitRemiseRegul.type === 'REFUND') {
                return roundAmount(Math.max(0, currentBalance));
            }

            return roundAmount(Math.max(0, -currentBalance));
        }

        function updateSuggestedAllocations() {
            var totalAmount = roundAmount(Number(vm.impactPenalitRemiseRegul.montantTtc || 0));
            var remainingTotal = 0;
            var remainingLines = [];
            var allocatedTotal = 0;

            angular.forEach(vm.lignecontrats, function(ligneContrat) {
                ligneContrat.montantAffecte = 0;

                var remaining = getRemainingToBePaid(ligneContrat);
                if (remaining > 0) {
                    remainingLines.push(ligneContrat);
                    remainingTotal += remaining;
                }
            });

            if (totalAmount <= 0 || remainingTotal <= 0) {
                return;
            }

            angular.forEach(remainingLines, function(ligneContrat, index) {
                var remaining = getRemainingToBePaid(ligneContrat);
                var suggestedAmount = roundAmount((totalAmount * remaining) / remainingTotal);

                if (index === remainingLines.length - 1) {
                    suggestedAmount = roundAmount(totalAmount - allocatedTotal);
                }

                ligneContrat.montantAffecte = suggestedAmount;
                allocatedTotal = roundAmount(allocatedTotal + suggestedAmount);
            });
        }

        function getAllocatedTotal() {
            var allocatedTotal = 0;

            angular.forEach(vm.lignecontrats, function(ligneContrat) {
                allocatedTotal += Number(ligneContrat.montantAffecte || 0);
            });

            return roundAmount(allocatedTotal);
        }

        function getCurrentBaseTotal() {
            var currentBaseTotal = 0;

            angular.forEach(vm.lignecontrats, function(ligneContrat) {
                currentBaseTotal += Number(getRemainingToBePaid(ligneContrat) || 0);
            });

            return roundAmount(currentBaseTotal);
        }

        function hasValidAllocatedTotal() {
            var totalAmount = roundAmount(Number(vm.impactPenalitRemiseRegul.montantTtc || 0));
            return totalAmount > 0
                && vm.lignecontrats.length > 0
                && getAllocatedLines().length > 0
                && getAllocatedTotal() === totalAmount;
        }

        function getAllocatedLines() {
            return vm.lignecontrats.filter(function(ligneContrat) {
                return Number(ligneContrat.montantAffecte || 0) > 0;
            });
        }

        function buildPayload() {
            return {
                type: vm.impactPenalitRemiseRegul.type,
                montantTtc: roundAmount(Number(vm.impactPenalitRemiseRegul.montantTtc || 0)),
                label: vm.impactPenalitRemiseRegul.label,
                commentaire: vm.impactPenalitRemiseRegul.commentaire,
                typeAvoir: vm.impactPenalitRemiseRegul.typeAvoir,
                typeRemisecommerciale: vm.impactPenalitRemiseRegul.typeRemisecommerciale,
                lignes: getAllocatedLines().map(function(ligneContrat) {
                    return {
                        ligneContrat: {id: ligneContrat.id},
                        montantTtc: roundAmount(Number(ligneContrat.montantAffecte || 0))
                    };
                })
            };
        }

        function save() {
            vm.isSaving = true;

            ImpactPenalitRemiseRegul.saveMulti(buildPayload(), onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $scope.$emit('wamasysApp:impactPenalitRemiseRegulUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function hasExistingBilling(ligneContrat) {
            return !!(ligneContrat
                && ((ligneContrat.derniereLignePaiement && ligneContrat.derniereLignePaiement.id)
                || ligneContrat.lastBillingDate));
        }

        function getCurrentBalance(ligneContrat) {
            if (!ligneContrat) {
                return 0;
            }

            if (ligneContrat.moneyboxApresPaiement !== undefined && ligneContrat.moneyboxApresPaiement !== null) {
                return Number(ligneContrat.moneyboxApresPaiement);
            }

            if (ligneContrat.derniereLignePaiement
                && ligneContrat.derniereLignePaiement.moneyboxApresPaiement !== undefined
                && ligneContrat.derniereLignePaiement.moneyboxApresPaiement !== null) {
                return Number(ligneContrat.derniereLignePaiement.moneyboxApresPaiement);
            }

            return 0;
        }

        function roundAmount(amount) {
            return Math.round(Number(amount || 0) * 100) / 100;
        }
    }
})();
